/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoFacebookIcon24Solid = forwardRef('LogoFacebookIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M16.652 13.445 17.184 10H14V7.873C14 6.925 14.31 6 15.8 6H17V3.048s-1.048-.235-2.36-.235c-2.741 0-4.64 1.661-4.64 4.668V10H7v3.445h3V22h4v-8.555h2.652Z" })));
});
